import React, { useState, useEffect, useMemo } from 'react';
import api from '../services/api';

const ApiLogsPage = () => {
    const [logs, setLogs] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [typeFilter, setTypeFilter] = useState("all");
    const [statusFilter, setStatusFilter] = useState("all");
    const [selectedLog, setSelectedLog] = useState(null); // Detay modalı için

    useEffect(() => {
        document.title = 'PayzoPay - API Logları';
        const fetchLogs = async () => {
            try {
                const res = await api.getApiLogs();
                setLogs(res.data);
            } catch (error) {
                console.error("Loglar çekilemedi", error);
            }
        };
        fetchLogs();
        const interval = setInterval(fetchLogs, 10000);
        return () => clearInterval(interval);
    }, []);

    const filteredLogs = useMemo(() => {
        return logs.filter(log => {
            const searchLower = searchTerm.toLowerCase();
            const matchesSearch = !searchTerm ||
                (log.fullname && log.fullname.toLowerCase().includes(searchLower)) ||
                (log.userId && log.userId.toLowerCase().includes(searchLower)) ||
                (log.transactionId && log.transactionId.toLowerCase().includes(searchLower)) ||
                (log.apiKeyName && log.apiKeyName.toLowerCase().includes(searchLower)) ||
                (log.errorCode && log.errorCode.toLowerCase().includes(searchLower)) ||
                (log.ipAddress && log.ipAddress.includes(searchTerm));

            const matchesType = typeFilter === "all" || log.requestType === typeFilter;
            const matchesStatus = statusFilter === "all" ||
                (statusFilter === "success" && log.success) ||
                (statusFilter === "error" && !log.success);

            return matchesSearch && matchesType && matchesStatus;
        });
    }, [logs, searchTerm, typeFilter, statusFilter]);

    const stats = useMemo(() => {
        return {
            total: logs.length,
            success: logs.filter(l => l.success).length,
            errors: logs.filter(l => !l.success).length,
            deposits: logs.filter(l => l.requestType === 'deposit').length,
            withdrawals: logs.filter(l => l.requestType === 'withdrawal').length
        };
    }, [logs]);

    // Stiller
    const cardStyle = (borderColor, textColor) => ({
        backgroundColor: 'var(--card-bg)', borderRadius: '8px', padding: '20px',
        borderLeft: `5px solid ${borderColor}`, flex: 1, minWidth: '150px',
        boxShadow: 'var(--shadow)', color: 'var(--text-color)'
    });
    const inputStyle = { padding: '8px', borderRadius: '4px', border: '1px solid var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)' };
    const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const modalContentStyle = { backgroundColor: 'var(--card-bg)', padding: '20px', borderRadius: '8px', width: '600px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto', color: 'var(--text-color)' };

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ color: 'var(--text-color)', margin: 0 }}>API Logları</h2>
                <button onClick={() => window.location.reload()} style={{ padding: '8px 15px', cursor: 'pointer', backgroundColor: 'var(--input-bg)', border: '1px solid var(--input-border)', color: 'var(--text-color)', borderRadius: '4px' }}>Yenile</button>
            </div>

            {/* İstatistikler */}
            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '20px' }}>
                <div style={cardStyle('#6c757d')}>
                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', opacity: 0.8 }}>Toplam İstek</h5>
                    <h3 style={{ margin: 0, fontSize: '1.5em' }}>{stats.total}</h3>
                </div>
                <div style={cardStyle('#28a745')}>
                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#28a745' }}>Başarılı</h5>
                    <h3 style={{ margin: 0, fontSize: '1.5em', color: '#28a745' }}>{stats.success}</h3>
                </div>
                <div style={cardStyle('#dc3545')}>
                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#dc3545' }}>Hatalı</h5>
                    <h3 style={{ margin: 0, fontSize: '1.5em', color: '#dc3545' }}>{stats.errors}</h3>
                </div>
                <div style={cardStyle('#007bff')}>
                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#007bff' }}>Yatırım</h5>
                    <h3 style={{ margin: 0, fontSize: '1.5em', color: '#007bff' }}>{stats.deposits}</h3>
                </div>
                <div style={cardStyle('#ffc107')}>
                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#ffc107' }}>Çekim</h5>
                    <h3 style={{ margin: 0, fontSize: '1.5em', color: '#ffc107' }}>{stats.withdrawals}</h3>
                </div>
            </div>

            {/* Filtreler */}
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap', backgroundColor: 'var(--card-bg)', padding: '15px', borderRadius: '8px', boxShadow: 'var(--shadow)' }}>
                <input
                    placeholder="İsim, ID, IP veya hata kodu ara..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    style={{ ...inputStyle, flex: 2, minWidth: '200px' }}
                />
                <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} style={{ ...inputStyle, flex: 1, minWidth: '120px' }}>
                    <option value="all">Tüm Tipler</option>
                    <option value="deposit">Yatırım</option>
                    <option value="withdrawal">Çekim</option>
                </select>
                <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{ ...inputStyle, flex: 1, minWidth: '120px' }}>
                    <option value="all">Tüm Durumlar</option>
                    <option value="success">Başarılı</option>
                    <option value="error">Hatalı</option>
                </select>
            </div>

            {/* Tablo */}
            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', color: 'var(--text-color)' }}>
                    <thead>
                        <tr style={{ backgroundColor: 'var(--table-header-bg)', textAlign: 'left' }}>
                            <th style={{ padding: '15px' }}>Tarih</th>
                            <th>Tip</th>
                            <th>Durum</th>
                            <th>Hata</th>
                            <th>Tutar</th>
                            <th>Banka</th>
                            <th>İsim</th>
                            <th>API Key</th>
                            <th>IP</th>
                            <th>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLogs.length === 0 ? (
                            <tr><td colSpan="10" style={{ padding: '20px', textAlign: 'center', color: 'var(--text-color)' }}>Kayıt bulunamadı.</td></tr>
                        ) : (
                            filteredLogs.map(log => (
                                <tr key={log._id} style={{ backgroundColor: !log.success ? 'rgba(220, 53, 69, 0.1)' : 'var(--table-row-even)', borderBottom: '1px solid var(--border-color)' }}>
                                    <td style={{ padding: '12px 15px', fontSize: '0.9em' }}>{new Date(log.createdAt).toLocaleString()}</td>
                                    <td>
                                        <span style={{ padding: '3px 8px', borderRadius: '15px', fontSize: '0.8em', backgroundColor: log.requestType === 'deposit' ? '#007bff' : '#6c757d', color: '#fff' }}>
                                            {log.requestType === 'deposit' ? 'Yatırım' : 'Çekim'}
                                        </span>
                                    </td>
                                    <td>
                                        <span style={{
                                            padding: '3px 8px', borderRadius: '4px', fontSize: '0.85em', fontWeight: 'bold',
                                            color: log.success ? '#28a745' : '#dc3545', border: `1px solid ${log.success ? '#28a745' : '#dc3545'}`
                                        }}>
                                            {log.success ? 'Başarılı' : 'Hata'}
                                        </span>
                                    </td>
                                    <td style={{ color: '#dc3545', fontSize: '0.85em' }}>{log.errorCode || '-'}</td>
                                    <td style={{ fontWeight: 'bold' }}>{log.requestedAmount ? `${Number(log.requestedAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL` : '-'}</td>
                                    <td style={{ fontSize: '0.9em' }}>{log.requestedBank || '-'}</td>
                                    <td style={{ fontSize: '0.9em' }}>{log.fullname || '-'}</td>
                                    <td style={{ fontSize: '0.9em' }}>{log.apiKeyName || '-'}</td>
                                    <td style={{ fontSize: '0.8em', fontFamily: 'monospace' }}>{log.ipAddress}</td>
                                    <td>
                                        <button onClick={() => setSelectedLog(log)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-color)' }}>
                                            <i className="fas fa-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {filteredLogs.length > 0 && (
                <div style={{ marginTop: '10px', textAlign: 'center', fontSize: '0.9em', color: '#6c757d' }}>
                    Toplam {filteredLogs.length} kayıt gösteriliyor
                </div>
            )}

            {/* Detay Modalı */}
            {selectedLog && (
                <div style={modalOverlayStyle} onClick={() => setSelectedLog(null)}>
                    <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', borderBottom: '1px solid var(--border-color)', paddingBottom: '10px' }}>
                            <h3 style={{ margin: 0 }}>API Log Detayı</h3>
                            <button onClick={() => setSelectedLog(null)} style={{ background: 'none', border: 'none', fontSize: '1.2em', cursor: 'pointer', color: 'var(--text-color)' }}>&times;</button>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>Tarih</label><div style={{ fontSize: '0.95em' }}>{new Date(selectedLog.createdAt).toLocaleString()}</div></div>
                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>İşlem Tipi</label><div style={{ fontSize: '0.95em' }}>{selectedLog.requestType === 'deposit' ? 'Yatırım' : 'Çekim'}</div></div>
                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>Durum</label><div style={{ fontSize: '0.95em', color: selectedLog.success ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>{selectedLog.success ? 'Başarılı' : 'Başarısız'}</div></div>
                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>HTTP Status</label><div style={{ fontSize: '0.95em' }}>{selectedLog.httpStatus}</div></div>

                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>API Key</label><div style={{ fontSize: '0.95em' }}>{selectedLog.apiKeyName || '-'}</div></div>
                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>IP Adresi</label><div style={{ fontSize: '0.95em', fontFamily: 'monospace' }}>{selectedLog.ipAddress || '-'}</div></div>

                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>Tutar</label><div style={{ fontSize: '0.95em' }}>{selectedLog.requestedAmount ? `${Number(selectedLog.requestedAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL` : '-'}</div></div>
                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>Banka</label><div style={{ fontSize: '0.95em' }}>{selectedLog.requestedBank || '-'}</div></div>

                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>İsim</label><div style={{ fontSize: '0.95em' }}>{selectedLog.fullname || '-'}</div></div>
                            <div><label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>User ID</label><div style={{ fontSize: '0.95em' }}>{selectedLog.userId || '-'}</div></div>

                            <div style={{ gridColumn: 'span 2' }}>
                                <label style={{ fontWeight: 'bold', fontSize: '0.85em', color: '#6c757d' }}>Transaction ID</label>
                                <div style={{ fontSize: '0.95em', fontFamily: 'monospace', backgroundColor: 'var(--input-bg)', padding: '5px', borderRadius: '4px' }}>
                                    {selectedLog.transactionId || 'Oluşmadı'}
                                </div>
                            </div>
                        </div>

                        {!selectedLog.success && (
                            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: 'rgba(220, 53, 69, 0.1)', borderRadius: '6px', border: '1px solid rgba(220, 53, 69, 0.3)' }}>
                                <label style={{ fontWeight: 'bold', color: '#dc3545', display: 'block', marginBottom: '5px' }}>Hata Detayı</label>
                                <div style={{ fontWeight: 'bold', color: '#dc3545' }}>Kod: {selectedLog.errorCode || '-'}</div>
                                <div style={{ color: '#dc3545', marginTop: '5px' }}>{selectedLog.errorMessage || 'Hata mesajı yok'}</div>
                            </div>
                        )}

                        <div style={{ marginTop: '20px', textAlign: 'right' }}>
                            <button onClick={() => setSelectedLog(null)} style={{ padding: '8px 20px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Kapat</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ApiLogsPage;